import "./product-details-info-left.scss";
import "components/jiffy/transfer-guides/transfer-guides";

export default () => {
  const toggle = document.querySelector(".js-product-details-info-left__bulk-discount-toggle");

  if (!toggle) {
    return;
  }

  toggle.addEventListener("click", () => {
    const targets = document.querySelectorAll(toggle.dataset.target);
    targets.forEach(target => {
      target.classList.toggle("show");
    });
  });
};
